import React from 'react';
import './TopNavBar.css';

const TopNavBar = () => {
  return (
    <nav className="top-navbar">
      <div className="navbar-container">
        <div className="nav-links">
          <a href="https://www.buildmyfishfinder.com" className="nav-link">
            Home
          </a>
          <span className="nav-divider">|</span>
          <a href="https://www.buildmyfishfinder.com/custom-builder" className="nav-link">
            Builder
          </a>
          <span className="nav-divider">|</span>
          <a href="/simple-products/livescope-plus-lvs34" className="nav-link">
            All Deals
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopNavBar; 